import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FC } from 'react';
import { Dialog } from '../../../dialog/dialog.styles';

export interface NotFeaturedReviewDialogProps {
  opened: boolean;
  onClose: () => void;
}

export const NotFeaturedReviewDialog: FC<NotFeaturedReviewDialogProps> = (props) => {
  const { opened, onClose } = props;

  return (
    <Dialog open={opened} maxWidth={false}>
      <DialogTitle sx={{ cursor: 'default' }}>Oops</DialogTitle>
      <DialogContent sx={{ width: '420px', padding: '10px 24px 24px 24px', lineHeight: '24px' }}>
        You're trying to reply to a review that is not marked as Featured - so neither the review nor your reply will be
        visible to the public. Please feature the review before proceeding.
      </DialogContent>
      <DialogActions sx={{ padding: '10px 24px 24px 24px' }}>
        <Button variant="contained" size="medium" onClick={onClose} disableElevation>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
